export default __webpack_public_path__ + "static/Comfortaa-Regular-17adcbfe059baae48f5c97184ee2b288.woff";